/// <reference path='../_all.ts' />

module navigation {
  'use strict';

  /**
   *
   */
  anchorNav.$inject = ['anchorNavService', '$timeout'];
  export function anchorNav(anchorNavService : IAnchorNavService, $timeout : ng.ITimeoutService): ng.IDirective {
    return {
      restrict: 'A',
      link: function (scope : IAnchorNavScope, element: ng.IAugmentedJQuery, attr: ng.IAttributes) {

        $timeout(() => {
          var title = attr["anchorTitle"];
          var useInScrollNav = attr["scrollMenuHide"] === undefined;
          anchorNavService.addElement(attr['anchorNav'], element[0], null, useInScrollNav, title);
        });
        
      }
    }
  }
}